import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import JSZip from "jszip";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

import {
  MUIIcons,
  H4,
  H2,
  DefaultButton,
  SecondaryButton,
  Btn,
} from "../../../../../../AbstractElements";
import {
  ALL_USERS_STATUS,
  STATUS_200,
  WBT,
} from "../../../../../../Api/constants";
import Divider from "../../../../../../CommonElements/Divider";
import FixedFooter from "../../../../../../CommonElements/FixedFooter";
import LabelTooltip from "../../../../../../CommonElements/LabelTooltip";
import MultiFileUpload from "../../../../../../CommonElements/MultiFileUpload/MultiFileUpload";
import MultiSelectDropdown from "../../../../../../CommonElements/MultiSelectDropdown";
import SliderModal from "../../../../../../CommonElements/SliderModal";
import CheckboxButton from "../../../../../../CommonElements/SwitchButton";
import TagInput from "../../../../../../CommonElements/TagInput";
import Comments from "../../../../../../container/Comments";
import MaterialDetails from "../../../../../../container/MaterialDetails";
import UploadedFileItem from "../../../../../../container/ThumbnailPreview";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../ReduxToolkit/Hooks";
import {
  addCommentToStages,
  getCourseContent,
  updateCommentStatus,
  updateCourseContent,
} from "../../../../../../ReduxToolkit/Reducers/CourseSlice";
import { createCourseMaterials } from "../../../../../../ReduxToolkit/Reducers/CourseStagesSlice";
import {
  getScormData,
  setScormToInitialValues,
} from "../../../../../../ReduxToolkit/Reducers/LearnerSlice";
import { getDomainList } from "../../../../../../ReduxToolkit/Reducers/MasterSlice";
import {
  getUsersList,
  uploadFileApi,
} from "../../../../../../ReduxToolkit/Reducers/UserSlice";
import {
  AddDescription,
  AddDuration,
  AddedMaterials,
  AddMaterial,
  ComingSoon,
  Comment,
  Description,
  Domain,
  DomainIsRequired,
  Duration,
  Enter,
  EnterComments,
  FileSizeNote,
  IsLaunchLimit,
  LearnerDocument,
  LearnerDocumentToolTipMessage,
  LimitNumber,
  Save,
  SaveAsDraft,
  Scorm,
  ScormDetails,
  ScormToUpload,
  Select,
  Tag,
  ThumbnailMaxSizeRequired,
  ThumbnailRequired,
  TrainerDocument,
  TrainerDocumentToolTipMessage,
  Upload,
  UPLOAD_SCORM_FILE,
  UploadScormFileToolTipMessage,
  UploadThumbnail,
  WBTDescriptionToolTipMessage,
  WBTDurationToolTipMessage,
  WBTLaunchLimitToolTipMessage,
  zipFileSizeNote,
} from "../../../../../../utils/Constant";
import {
  extractFileName,
  fileUrlKeys,
  getCurrentDate,
  handleKeyDownOnNumericWithDecimal,
  handleKeyDownOnNumericWithoutDecimal,
  MAX_FILE_SIZE_IN_BYTES_2MB,
  richTextSupportedItems,
  showToast,
  sortCommentsByDate,
} from "../../../../../../utils/helper/helper";
import {
  OPENED_SCORM_DETAILS,
  saveToLocalStorage,
} from "../../../../../../utils/helper/localStorageutils";
import useIsMobile from "../../../../../../utils/helper/responsive";

const CreateMaterials = () => {
  const isMobile = useIsMobile();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [isComentRead, setIsComentRead] = useState(null);
  const { courseContent } = useAppSelector(state => state.course);
  const { courseId } = location.state || "";
  const [sliderModal, setSliderModal] = useState(false);
  const [learnerDocument, setLearnerDocument] = useState([]);
  const [scromDocument, setScromDocument] = useState([]);
  const [trainerDocument, setTrainerDocument] = useState([]);
  const [duration, setDuration] = useState("");
  const [domain, setDomain] = useState([]);
  const [thumbnail, setThumbnail] = useState(null);
  const [tags, setTags] = useState([]);
  const [description, setDescription] = useState("");
  const [isLaunchLimit, setIsLaunchLimit] = useState(false);
  const [launchLimit, setLaunchLimit] = useState(null);
  const [iconComments, setIconComments] = useState(null);
  const { usersList } = useAppSelector(state => state.user);
  const [commentList, setCommentList] = useState([]);
  const [userMap, setUserMap] = useState(null);
  const [materialData, setMaterialData] = useState([
    { documents: [], greeting: "Learner documents", paths: [] },
    { documents: [], greeting: "Trainer Documents", paths: [] },
  ]);
  const { domainList } = useAppSelector(state => state.master);
  const [domainListData, setDomainListData] = useState([]);

  useEffect(() => {
    dispatch(getUsersList({ role: ALL_USERS_STATUS }));
    dispatch(getCourseContent({ id: courseId }));
  }, [dispatch, courseId]);

  useEffect(() => {
    dispatch(getDomainList());
  }, [dispatch]);

  useEffect(() => {
    const userMapObj = {};
    usersList?.users?.forEach(user => {
      userMapObj[user.id] = user;
    });
    setUserMap(userMapObj);
  }, [usersList]);

  useEffect(() => {
    if (courseId) {
      dispatch(getCourseContent({ id: courseId }));
    }
  }, [dispatch, courseId]);

  useEffect(() => {
    const domains = [];
    domainList?.domain?.forEach(element => {
      domains.push({
        name: element.id.toString(),
        value: element.domain_name,
        label: element.domain_name,
      });
    });
    setDomainListData(domains);
  }, [domainList]);

  useEffect(() => {
    let comment = [];
    if (courseContent?.comment?.course_material) {
      comment = sortCommentsByDate(courseContent.comment.course_material);
    }
    setCommentList(comment);

    if (courseContent?.comment?.comment_status) {
      try {
        const infoStage = courseContent?.comment?.comment_status?.find(
          (stage: { stages: string }) => stage.stages === "course_material"
        );
        setIsComentRead(infoStage ? !infoStage.is_read : false);
      } catch (error) {
        setIsComentRead(false);
      }
    }
    const contents = [
      { documents: [], greeting: "Learner documents", paths: [] },
      { documents: [], greeting: "Trainer Documents", paths: [] },
    ];
    if (courseContent) {
      courseContent?.course_materials?.forEach(element => {
        if (element?.file_category === "learner_document") {
          contents[0].documents.push(element.file_name);
          contents[0].paths.push(element.file_url);
        } else {
          contents[1].documents.push(element.file_name);
          contents[1].paths.push(element.file_url);
        }
      });
    }
    setThumbnail(courseContent?.thumbnail_url || null);
    setTags(courseContent?.tags);
    if (courseContent?.course_type === WBT) {
      const scromFile: any = contents[0];
      scromFile.greeting = Scorm;
      if (scromFile?.documents?.length > 0)
        setDuration(courseContent?.duration?.toString() || "");
      setDescription(courseContent?.description || "");

      const domainsData = [];
      const domainsDataIds = courseContent?.wbt_domain?.map(item =>
        item?.id?.toString()
      );
      domainList?.domain?.forEach(element => {
        if (domainsDataIds?.includes(element?.id?.toString()))
          domainsData.push({
            name: element.id.toString(),
            value: element.domain_name,
            label: element.domain_name,
          });
      });
      setDomain(domainsData);

      setMaterialData([scromFile]);
    } else {
      setMaterialData(contents);
    }
  }, [courseContent]);

  const uploadFile = async (documents, type = "") => {
    let keys;

    if (courseContent?.course_type === WBT) {
      keys = fileUrlKeys?.scorm;
    } else {
      keys = fileUrlKeys?.course_material_files;
    }
    if (type === "thumbnail") {
      keys = fileUrlKeys?.thumbnails;
    }

    const postData = new FormData();
    documents?.forEach(file => {
      postData.append("files", file);
    });
    const response = await dispatch(
      uploadFileApi({
        content: postData,
        key: keys,
      })
    );
    return response?.payload?.data?.file_urls;
  };

  const checkDocuments = (documents: any[]) => {
    if (!documents || documents?.length === 0) {
      return true;
    }
    return false;
  };

  const handleComplete = async (type, materialData, fileDelete = false) => {
    if (courseContent?.course_type === WBT && type === "completed") {
      if (!description || description === "") {
        showToast(AddDescription, "error");
        return;
      }

      if (!domain || domain?.length === 0) {
        showToast(DomainIsRequired, "error");
        return;
      }

      if (!duration || duration === "" || duration === "0") {
        showToast(AddDuration, "error");
        return;
      }

      if (!thumbnail || thumbnail === "" || thumbnail === null) {
        showToast(ThumbnailRequired, "error");
        return;
      }

      if (
        !fileDelete &&
        checkDocuments(scromDocument) &&
        checkDocuments(materialData?.[0]?.documents)
      ) {
        showToast(ScormToUpload, "error");
        return;
      }
    }

    if (courseContent?.course_type !== WBT && type === "completed") {
      if (!thumbnail || thumbnail === "" || thumbnail === null) {
        showToast(ThumbnailRequired, "error");
        return;
      }
    }

    const materials = [];
    let allfiles = [];
    if (learnerDocument?.length > 0) {
      allfiles = [...allfiles, ...learnerDocument];
    }
    if (trainerDocument?.length > 0) {
      allfiles = [...allfiles, ...trainerDocument];
    }
    if (scromDocument?.length > 0) {
      allfiles = [...allfiles, ...scromDocument];
    }
    let files = [];

    if (allfiles.length > 0) files = await uploadFile(allfiles);

    if (courseContent?.course_type !== WBT) {
      if (files?.length > 0) {
        files.forEach((fileUrl, index) => {
          if (index < learnerDocument?.length) {
            const fileName = extractFileName(fileUrl);
            const fileExtension = fileName.substring(
              fileName.lastIndexOf(".") + 1
            );
            materials.push({
              file_name: fileUrlKeys?.course_material_files + "/" + fileName,
              file_type: fileExtension,
              file_url: fileUrlKeys?.course_material_files + "/" + fileName,
              file_category: "learner_document",
            });
          }
          if (index >= learnerDocument?.length && index < files.length) {
            const fileName = extractFileName(fileUrl);
            const fileExtension = fileName.substring(
              fileName.lastIndexOf(".") + 1
            );
            materials.push({
              file_name: fileUrlKeys?.course_material_files + "/" + fileName,
              file_type: fileExtension,
              file_url: fileUrlKeys?.course_material_files + "/" + fileName,
              file_category: "trainer_document",
            });
          }
        });
      }
      if (materialData) {
        materialData[0]?.documents?.forEach((_item, index) => {
          const fileName = extractFileName(materialData[0]?.paths[index]);
          const fileExtension = fileName.substring(
            fileName.lastIndexOf(".") + 1
          );
          materials.push({
            file_name: fileUrlKeys?.course_material_files + "/" + fileName,
            file_type: fileExtension,
            file_url: fileUrlKeys?.course_material_files + "/" + fileName,
            file_category: "learner_document",
          });
        });
        materialData[1]?.documents?.forEach((_item, index) => {
          const fileName = extractFileName(materialData[1]?.paths[index]);
          const fileExtension = fileName.substring(
            fileName.lastIndexOf(".") + 1
          );
          materials.push({
            file_name: fileUrlKeys?.course_material_files + "/" + fileName,
            file_type: fileExtension,
            file_url: fileUrlKeys?.course_material_files + "/" + fileName,
            file_category: "trainer_document",
          });
        });
      }
    } else if (courseContent?.course_type === WBT) {
      if (files?.length > 0) {
        files.forEach(fileUrl => {
          const fileName = extractFileName(fileUrl);
          const fileExtension = fileName.substring(
            fileName.lastIndexOf(".") + 1
          );
          materials.push({
            file_name: fileUrlKeys?.scorm + "/" + fileName,
            file_type: fileExtension,
            file_url: fileUrlKeys?.scorm + "/" + fileName,
            file_category: "learner_document",
          });
        });
      }
      if (materialData) {
        materialData[0]?.documents?.forEach((_item, index) => {
          const fileName = extractFileName(materialData[0]?.paths[index]);
          const fileExtension = fileName.substring(
            fileName.lastIndexOf(".") + 1
          );
          materials.push({
            file_name: fileUrlKeys?.scorm + "/" + fileName,
            file_type: fileExtension,
            file_url: fileUrlKeys?.scorm + "/" + fileName,
            file_category: "learner_document",
          });
        });
      }
    }

    const allDomains = domain?.map(item => Number(item.name)) || [];

    const materialsObject = {
      course_id: courseId,
      materials: materials,
      duration: duration === "" || !duration ? null : parseInt(duration),
      status: type,
      wbt_domain: allDomains,
      wbt_is_launch: false,
      wbt_launch_count: null,
      description: description,
    };

    let uploadedFile = "";
    if (thumbnail && thumbnail instanceof File) {
      uploadedFile = await uploadFile([thumbnail], "thumbnail");
    } else {
      uploadedFile = fileUrlKeys?.thumbnails + "/" + extractFileName(thumbnail);
    }

    const combinedArray = [
      ...(courseContent?.competency_statement?.tool_aid?.tool || []),
      ...(courseContent?.competency_statement?.tool_aid?.training_aid || []),
    ];

    if (thumbnail === null || thumbnail === "") {
      uploadedFile = "";
    }

    const { ...rest } = courseContent;
    const flatCourseContent = {
      ...rest,
      status: courseContent?.status,
      min_attendance: courseContent.additional_information.min_attendance,
      max_attendance: courseContent.additional_information.max_attendance,
      suggested_reading: courseContent.additional_information.suggested_reading,
      qualification_certification:
        courseContent.additional_information.qualification_certification,
      assessment_criteria:
        courseContent.additional_information.assessment_criteria,
      theory_time_ratio:
        courseContent.additional_information.theory_time_ratio || 0,
      practical_time_ratio:
        courseContent.additional_information.practical_time_ratio || 0,
      tooling_aids_required:
        courseContent.additional_information.tooling_aids_required,
      date:
        !courseContent.competency_statement.date ||
        courseContent.competency_statement.date === "" ||
        courseContent.competency_statement.date === "None"
          ? getCurrentDate()
          : courseContent.competency_statement.date,
      prerequisite: courseContent.competency_statement.prerequisite,
      version: courseContent.competency_statement.version,
      conditions: courseContent.competency_statement.conditions,
      min_requirements: courseContent.competency_statement.min_requirements,
      media_demonstration:
        courseContent.competency_statement.media_demonstration,
      estimated_time: courseContent.competency_statement.estimated_time,
      classroom_lab: courseContent.competency_statement.classroom_lab,
      resources: combinedArray || [],
      webinar_link: courseContent?.competency_statement?.webinar_link || "",
      reference: courseContent.competency_statement.reference,
      resources_activity: courseContent.competency_statement.resources_activity,
      review: courseContent.competency_statement.review,
      assessment: courseContent.competency_statement.assessment,
      intended_audience: courseContent.additional_information.intended_audience,
      other_intended_audiences:
        courseContent.additional_information.other_intended_audiences,
      pre_course_work:
        courseContent.additional_information.pre_course_work || [],
      other_pre_course_works:
        courseContent.additional_information.other_pre_course_works || "",
      class_room_ratio: courseContent.competency_statement.class_room_ratio,
      practical_class_ratio:
        courseContent.competency_statement.practical_class_ratio,
      other_references: courseContent?.competency_statement?.other_references,
      other_tools: courseContent?.competency_statement?.other_tools,
      other_training_aids:
        courseContent?.competency_statement?.other_training_aids,
      other_prerequisites:
        courseContent?.competency_statement?.other_prerequisites,
      practical_activity_details:
        courseContent?.additional_information?.practical_activity_details,
      registration_requirement:
        courseContent?.additional_information?.registration_requirement,
      description: description || "",
      tags: tags,
      thumbnail_url:
        thumbnail instanceof File ? uploadedFile?.[0] : uploadedFile || "",
    };

    await dispatch(updateCourseContent({ courseContent: flatCourseContent }));

    const res = await dispatch(
      createCourseMaterials({ materialsData: materialsObject })
    );
    if (res?.payload?.status_code === STATUS_200 && res?.payload?.message) {
      showToast(res?.payload?.message, "success");
    }

    await dispatch(getCourseContent({ id: courseId }));
    setLearnerDocument(null);
    setTrainerDocument(null);
    setScromDocument(null);
    if (!fileDelete)
      return navigate(
        `${process.env.PUBLIC_URL}/course-management/course-details?courseId=${courseId}`
      );
  };

  const onCommentsChange = e => {
    if (
      (e.target.value && e.target.value?.length <= 255) ||
      e.target.value === ""
    )
      setIconComments(e.target.value);
  };

  const sliderToggle = async () => {
    setSliderModal(!sliderModal);
    await dispatch(
      updateCommentStatus({
        correspondingStatus: {
          component_name: "course_material",
          course_id: courseId,
        },
      })
    );
    setIsComentRead(false);
  };

  const onSendComments = async () => {
    if (iconComments === "") {
      showToast(EnterComments, "error");
      return;
    }

    const payload = {
      course_id: courseId,
      is_comment: true,
      comment_data: {
        entity_type: "course_material",
        comment: iconComments,
      },
    };

    await dispatch(addCommentToStages({ comment: payload }));
    await dispatch(getCourseContent({ id: courseId }));
    setIconComments("");
  };

  const onDeleteFile = (fileType: number, fileIndex: number) => {
    const fileData = [...materialData];
    fileData[fileType].documents.splice(fileIndex, 1);
    fileData[fileType].paths.splice(fileIndex, 1);
    setMaterialData(fileData);
    handleComplete("draft", fileData, true);
  };

  const onPlayFile = async (fileType: number, fileIndex: number) => {
    try {
      const scormResponse = await dispatch(
        getScormData({ courseId: courseContent?.id.toString() })
      );
      const fileData = [...materialData];
      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
      const scormPackagePath = fileData[fileType].paths[fileIndex];
      if (scormPackagePath.includes(".zip")) {
        const response = await fetch(scormPackagePath);
        const blob = await response.blob();
        const zip = await JSZip.loadAsync(blob);
        const files = [];
        zip.forEach((relativePath, file) => {
          files.push({ path: relativePath, file });
        });

        const indexFile = files.find(
          f =>
            f.path.endsWith("index.html") || f.path.endsWith("launchpage.html")
        );
        if (indexFile) {
          const content = await indexFile.file.async("string");
          const blob = new Blob([content], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          const width = 1400;
          const height = 700;
          const left = window.screen.width / 2 - width / 2;
          const top = window.screen.height / 2 - height / 2;
          if (scormResponse?.payload?.data?.scorm_data) {
            saveToLocalStorage(
              OPENED_SCORM_DETAILS,
              scormResponse.payload.data
            );
          } else {
            saveToLocalStorage(OPENED_SCORM_DETAILS, {
              course_name: courseContent?.course_name,
              course_id: courseContent?.id.toString(),
              scorm_data: {},
            });
          }
          window.open(
            url,
            "_blank",
            `width=${width},height=${height},top=${top},left=${left}`
          );
        }
      }
    } catch (e) {
      dispatch(setScormToInitialValues());
      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
    }
  };

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE_IN_BYTES_2MB) {
        showToast(ThumbnailMaxSizeRequired, "error");
        e.target.value = "";
        return;
      }

      setThumbnail(file);
    }
  };

  const handleRemoveImage = () => {
    setThumbnail(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleThumbnailButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="page-body pb-5">
      <SliderModal isOpen={sliderModal} toggle={sliderToggle}>
        <H2>{Comment}</H2>
        <Divider />
        <Comments
          userMap={userMap}
          text={iconComments}
          comments={commentList}
          send
          onSendComments={onSendComments}
          onCommentsChange={onCommentsChange}
        />
      </SliderModal>
      {materialData &&
        (materialData[0]?.documents?.length > 0 ||
          materialData[1]?.documents?.length > 0) && (
          <div className="mt-4">
            <MaterialDetails
              title={AddedMaterials}
              data={materialData}
              showDelete
              duration={duration}
              setDuration={setDuration}
              showPlay={courseContent?.course_type === WBT}
              onDeleteFile={onDeleteFile}
              onPlayFile={onPlayFile}
              courseContent={courseContent}
            />
          </div>
        )}
      <Card className={isMobile && "custom-mobile-card pb-5"}>
        <CardHeader className="d-flex justify-content-between">
          <H4 className="mt-2">
            {courseContent?.course_type !== WBT ? AddMaterial : ScormDetails}
          </H4>
          <div className="comment-icon-container">
            <MUIIcons
              size={24}
              onClick={sliderToggle}
              className="primary-icon-color mt-2 pointer"
              iconName="ChatBubbleOutlineOutlined"
            />
            {isComentRead != null && isComentRead && (
              <span className="red-dot"></span>
            )}
          </div>
        </CardHeader>
        <CardBody>
          {courseContent?.course_type !== WBT && (
            <>
              <div className="mb-3">
                <LabelTooltip
                  label={`${Upload} ${LearnerDocument}`}
                  tooltipText={LearnerDocumentToolTipMessage}
                  important={false}
                />
                <MultiFileUpload
                  materials
                  note={FileSizeNote}
                  onFileChange={(file: any, status) => {
                    if (status === "removed") {
                      setLearnerDocument(prevDocuments =>
                        prevDocuments.filter(item => item.name !== file.name)
                      );
                    } else if (status === "done" && file) {
                      setLearnerDocument(prevDocuments => [
                        ...(Array.isArray(prevDocuments) ? prevDocuments : []),
                        file,
                      ]);
                    }
                  }}
                />
              </div>
              <Divider />
              <div className="mt-2 mb-2">
                <LabelTooltip
                  label={`${Upload} ${TrainerDocument}`}
                  tooltipText={TrainerDocumentToolTipMessage}
                  important={false}
                />
                <MultiFileUpload
                  materials
                  note={FileSizeNote}
                  onFileChange={(file: any, status) => {
                    if (status === "removed") {
                      setTrainerDocument(prevDocuments =>
                        prevDocuments.filter(item => item.name !== file.name)
                      );
                    } else if (status === "done" && file) {
                      setTrainerDocument(prevDocuments => [
                        ...(Array.isArray(prevDocuments) ? prevDocuments : []),
                        file,
                      ]);
                    }
                  }}
                />
              </div>
              <Divider />
              <Row className="mt-2 mb-2">
                <Col lg="6" md="6" sm="12" xs="12">
                  <FormGroup>
                    <LabelTooltip
                      label={Tag}
                      tooltipText={Tag}
                      important={false}
                    />
                    <TagInput
                      initialTags={tags}
                      onTagsChange={values => {
                        setTags(values);
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col lg="6" md="6" sm="12" xs="12">
                  <LabelTooltip
                    label={UploadThumbnail}
                    tooltipText={UploadThumbnail}
                    important
                  />
                  <Row>
                    <Col lg="4" md="4" sm="12" xs="12">
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <Btn
                        outline
                        className="alert-light-primary"
                        color="primary"
                        onClick={handleThumbnailButtonClick}
                      >
                        {UploadThumbnail}
                      </Btn>
                    </Col>
                    <Col lg="8" md="8" sm="12" xs="12">
                      {thumbnail && (
                        <UploadedFileItem
                          fileName={
                            thumbnail ? thumbnail?.name : "Selected Image"
                          }
                          thumbnailUrl={thumbnail}
                          onDelete={handleRemoveImage}
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {courseContent?.course_type === WBT && (
            <>
              <Row>
                <Col lg="12" md="12" sm="12" xs="12">
                  <LabelTooltip
                    important
                    label={Description}
                    tooltipText={WBTDescriptionToolTipMessage}
                  />
                  <CKEditor
                    onChange={(_event, editor) => {
                      const data = editor.getData();
                      setDescription(data);
                    }}
                    config={{
                      toolbar: {
                        items: richTextSupportedItems,
                      },
                      placeholder: Enter + " " + Description,
                    }}
                    editor={ClassicEditor as any}
                    data={description}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg="6" md="6" sm="12" xs="12">
                  <LabelTooltip
                    label={Domain}
                    tooltipText={`${Select} ${Domain}`}
                    important
                  />
                  <MultiSelectDropdown
                    onChange={values => {
                      const selectedData =
                        domainListData
                          ?.filter(item => values?.includes(item?.name))
                          ?.map(item => ({
                            name: item.name,
                            value: item.label,
                            label: item.label,
                          })) || [];
                      setDomain(selectedData);
                    }}
                    options={domainListData}
                    placeholder={`${Select} ${Domain}`}
                    defaultSelected={domain}
                  />
                </Col>
                <Col lg="6" md="6" sm="12" xs="12">
                  <LabelTooltip
                    label={UploadThumbnail}
                    tooltipText={UploadThumbnail}
                    important
                  />
                  <Row>
                    <Col lg="4" md="4" sm="12" xs="12">
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <Btn
                        outline
                        className="alert-light-primary"
                        color="primary"
                        onClick={handleThumbnailButtonClick}
                      >
                        {UploadThumbnail}
                      </Btn>
                    </Col>
                    <Col lg="8" md="8" sm="12" xs="12">
                      {thumbnail && (
                        <UploadedFileItem
                          fileName={
                            thumbnail ? thumbnail?.name : "Selected Image"
                          }
                          thumbnailUrl={thumbnail}
                          onDelete={handleRemoveImage}
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className={!thumbnail && "mt-3"}>
                <Col lg="6" md="6" sm="12" xs="12">
                  <LabelTooltip
                    important
                    label={Duration}
                    tooltipText={WBTDurationToolTipMessage}
                  />
                  <Input
                    type="number"
                    name="duration"
                    inputMode="numeric"
                    value={duration}
                    onChange={e => {
                      setDuration(e.target.value);
                    }}
                    placeholder={`${Enter} ${Duration}`}
                    onKeyDown={handleKeyDownOnNumericWithoutDecimal}
                    min={0}
                    max={1000}
                  />
                </Col>
                <Col lg="6" md="6" sm="12" xs="12" className="d-flex">
                  <div className="d-flex gap-2 mt-4 w-75">
                    <p className="fw-bold">
                      <LabelTooltip
                        label={IsLaunchLimit}
                        tooltipText={WBTLaunchLimitToolTipMessage}
                        important={false}
                      />
                    </p>
                    <div className="mt-1">
                      <CheckboxButton
                        onChange={() => {
                          showToast(ComingSoon, "warning");
                          setIsLaunchLimit(false);
                        }}
                        checked={false}
                      />
                    </div>
                  </div>
                  {isLaunchLimit && (
                    <div className="w-100">
                      <FormGroup>
                        <LabelTooltip
                          label={LimitNumber}
                          tooltipText={LimitNumber}
                          important
                        />
                        <Input
                          onChange={e => {
                            setLaunchLimit(e.target.value);
                          }}
                          type="number"
                          inputMode="numeric"
                          step={0.5}
                          onKeyDown={handleKeyDownOnNumericWithDecimal}
                          value={launchLimit}
                          name="limit_number"
                          placeholder={`${Enter} ${LimitNumber}`}
                          min={0}
                        />
                      </FormGroup>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="mt-3 mb-3">
                {materialData[0]?.documents?.length == 0 && (
                  <Col lg="6" md="6" sm="12" xs="12">
                    <LabelTooltip
                      label={UPLOAD_SCORM_FILE}
                      tooltipText={UploadScormFileToolTipMessage}
                      important
                    />
                    <MultiFileUpload
                      materials={false}
                      note={zipFileSizeNote}
                      onFileChange={(file: any, status) => {
                        if (status === "removed") {
                          setDuration("");
                          setScromDocument(prevDocuments =>
                            prevDocuments.filter(
                              item => item.name !== file.name
                            )
                          );
                        } else if (status === "done" && file) {
                          setScromDocument(prevDocuments => [
                            ...(Array.isArray(prevDocuments)
                              ? prevDocuments
                              : []),
                            file,
                          ]);
                        }
                      }}
                      multiple={false}
                      accept=".zip"
                    />
                  </Col>
                )}
                <Col lg="6" md="6" sm="12" xs="12">
                  <FormGroup>
                    <LabelTooltip
                      label={Tag}
                      tooltipText={Tag}
                      important={false}
                    />
                    <TagInput
                      initialTags={tags}
                      onTagsChange={values => {
                        setTags(values);
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          )}
        </CardBody>
      </Card>
      <FixedFooter>
        <SecondaryButton onClick={() => handleComplete("draft", materialData)}>
          {SaveAsDraft}
        </SecondaryButton>

        <Row>
          <Col xs="auto">
            <DefaultButton
              onClick={() => handleComplete("completed", materialData)}
              color="primary"
            >
              {Save}
            </DefaultButton>
          </Col>
        </Row>
      </FixedFooter>
    </div>
  );
};

export default CreateMaterials;
